/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var mq = __webpack_require__(1);
	var ID = {
	    mv: "#mv",
	    mvInner: "#mv-inner",
	    mvStage: "#mv-stage",
	    mvStageInner: "#mv-stage-inner",
	    mvControl: "#mv-control",
	    spc: "#special",
	    spcStage: "#special-stage",
	    spcControl: "#special-control",
	    column: "#column",
	    localInfo: "#local-information",
	    news: "#news",
	    movie: "#movie",
	    movieList: "#movie-list",
	    movieListControl: "#movie-list-control",
	    movieListPages: "#movie-list-pages"
	};
	var $o = {};
	var initialized = false;
	
	// 縦幅
	// var obj_h = {
	//     // mv: 0,
	//     column: 0
	// };
	
	// オフセット位置
	var obj_pos = {
	    column: 0,
	    localInfo: 0
	};
	
	/** 
	 *  初期化
	 */
	function initialize() {
	    var defer = $.Deferred();
	
	    _.each(ID, function(id, key) {
	        $o[key] = $(id);
	    });
	
	    defer.resolve();
	
	    return defer;
	}
	
	/** 
	 *  基本イベントの初期化
	 */
	function initEvent() {
	    var movie_pages = $('li', $o.movieList).length;
	
	    $o.mvStageInner.slick({
	        arrows: false,
	        fade: true,
	        autoplay: true,
	        speed: 1000,
	        autoplaySpeed: 3000,
	        draggable: false,
	        pauseOnHover: false,
	        swipe: false
	    });
	
	    $o.mvStageInner.on('beforeChange', function(event, slick, current, next) {
	        $('.current', $o.mvControl).removeClass('current');
	        $('div', $o.mvControl).eq(next).addClass('current');
	    });
	
	    $('div', $o.mvControl).on('click', function() {
	        var i = $(this).index();
	        if(!$(this).hasClass('current')) {
	            $o.mvStageInner.slick('slickGoTo', i);
	        }
	        return false;
	    });
	
	    $o.movieList.slick({
	        arrows: false,
	        slidesToShow: 2,
	        slidesToScroll: 2,
	        infinite: false,
	        responsive: [
	            {
	                breakpoint: 768,
	                settings: {
	                    slidesToShow: 1,
	                    slidesToScroll: 1
	                }
	            }
	        ]
	    });
	
	    $(window).on('resize.home-movie', function() {
	        $o.movieList.slick('slickGoTo', 0);
	
	        $('.next', $o.movieListControl).addClass('disable');
	        $('.prev', $o.movieListControl).addClass('disable');
	
	        if($(window).width() <= 768) {
	            movie_pages = $('li', $o.movieList).length - 1;
	
	            if($('li', $o.movieList).length > 1) {
	                $('.next', $o.movieListControl).removeClass('disable');
	            }
	        } else {
	            movie_pages = Math.ceil($('li', $o.movieList).length / 2);
	            
	            if($('li', $o.movieList).length > 2) {
	                $('.next', $o.movieListControl).removeClass('disable');
	            }
	        }
	    });
	
	    $(window).trigger('resize.home-movie');
	
	    $('.next', $o.movieListControl).on('click', function() {
	        if(!$(this).hasClass('disable')) {
	            $o.movieList.slick('slickNext');
	        }
	    });
	
	    $('.prev', $o.movieListControl).on('click', function() {
	        if(!$(this).hasClass('disable')) {
	            $o.movieList.slick('slickPrev');
	        }
	    });
	
	    $o.movieList.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	        $('.next', $o.movieListControl).removeClass('disable');
	        $('.prev', $o.movieListControl).removeClass('disable');
	    });
	
	    $o.movieList.on('afterChange', function(event, slick, currentSlide) {
	        
	
	        if(currentSlide >= movie_pages) {
	            $('.next', $o.movieListControl).addClass('disable');
	        }
	
	        if(currentSlide <= 0) {
	            $('.prev', $o.movieListControl).addClass('disable');
	        }
	    });
	
	    $("#movie-list").magnificPopup({
	        type: 'iframe',
	        delegate: 'a',
	        // gallery: {
	        //     enabled: true
	        // },
	        iframe: {
	            markup: '<div class="mfp-iframe-scaler">'+
	                '<div class="mfp-close"></div>'+
	                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
	                '</div>',
	            patterns: {
	                youtube: {
	                    index: 'youtube.com/',
	                    id: 'v=',
	                    src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1&showinfo=0'
	                },
	                youtube_short: {
	                    index: 'youtu.be/',
	                    id: '/',
	                    src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1&showinfo=0'
	                }
	            },
	            srcAction: 'iframe_src'
	        }
	    });
	
	    setSpecialContentsSlider();
	    setNewsTab();
	
	    if(Modernizr.matchmedia) {
	        addMqEvent();
	        window.matchMedia(mq.tablet).addListener(addMqEvent);
	    } else {
	        addLegacyEvent();
	    }
	}
	
	/** 
	 *  メディアクエリの影響のあるサイトの基本イベントを追加
	 */
	function addMqEvent() {
	    if(initialized === true) {
	        // MediaQueryの影響をうけるイベントの削除
	        $(window).off('.mq-home');
	        $('*').off('.mq-home');
	    }
	    
	    // SMP&Tablet版用イベント
	    if(window.matchMedia(mq.tablet).matches) {
	        $o.mv.css('height', '');
	        $('.mv-item', $o.mv).css('height', '');
	        $o.column.removeClass('fixed fixed-end');
	    }
	    // PC版用イベント
	    else {
	        setupPcEvent();
	    }
	
	    initialized = true;
	}
	
	/** 
	 *  matchMediaに対応していないブラウザ向け基本イベント追加
	 */
	function addLegacyEvent() {
	    setupPcEvent();
	}
	
	/** 
	 *  PC版基本イベント
	 */
	function setupPcEvent() {
	    $(window).on('resize.mq-home', function() {
	        setMainVisualHeight();
	        if( $o.column.length > 0 ) {
	            getColumnPos();
	        }
	        setColumnClass();
	    });
	    $(window).trigger('resize.mq-home');
	
	    $(window).on('scroll.mq-home', function() {
	        setColumnClass();
	    });
	    // $(window).trigger('scroll.mq-home');
	}
	
	/** 
	 *  メインビジュアルの高さを調整
	 */
	function setMainVisualHeight() {
	    var $admin_bar = $('#wpadminbar');
	    var admin_bar_h = $admin_bar.length > 0 ? $admin_bar.height() : 0;
	    var special_h = $o.spcStage.length > 0 ? $o.spcStage.height() : 0;
	    var h = "calc(100vh - " + special_h + "px - " + admin_bar_h  + "px)";
	    
	    $o.mv.css('height', h);
	
	    $('.mv-item', $o.mv).css('height', h);
	}
	
	/** 
	 *  各オブジェクトのオフセット位置を取得
	 */
	function getColumnPos() {
	    obj_pos.column = $o.column.offset().top;
	    obj_pos.localInfo = $o.localInfo.offset().top;
	}
	
	/** 
	 *  スクロール位置によってコラムのクラスを変更する
	 */
	function setColumnClass() {
	    var scroll = Math.abs($(window).scrollTop());
	
	    if(scroll > obj_pos.column) {
	        $o.column.removeClass('fixed-end').addClass('fixed');
	    }
	
	    if(scroll > (obj_pos.localInfo - 110)) {
	        $o.column.removeClass('fixed').addClass('fixed-end');
	    }
	
	    if(scroll <= obj_pos.column) {
	        $o.column.removeClass('fixed fixed-end');
	    }
	}
	
	/** 
	 * スペシャルコンテンツスライダー（要slick）
	 */
	function setSpecialContentsSlider() {
	    var $slider = $('ul', $o.spcStage);
	    var $control = $o.spcControl;
	    var $next = $('.next', $control);
	    var $prev = $('.prev', $control);
	    var settings = {
	        infinite: true,
	        slidesToShow: 4,
	        slidesToScroll: 1,
	        arrows: false,
	        responsive: [
	            {
	                breakpoint: 1024,
	                settings: {
	                    centerMode: true,
	                    slidesToShow: 2,
	                    initialSlide: 1,
	                    centerPadding: '60px'
	                }
	            }, {
	                breakpoint: 750,
	                settings: {
	                    centerMode: true,
	                    slidesToShow: 1,
	                    initialSlide: 0,
	                    centerPadding: '60px'
	                }
	            }
	        ]
	    };
	
	    if($('li', $slider).length > 4) {
	        settings.centerMode = true;
	        settings.centerPadding = '60px';
	        settings.initialSlide = 2;
	        // settings.responsive = 
	        
	    } else {
	        $o.spcStage.addClass('left-mode');
	    }
	    
	    $slider.slick(settings);
	
	    $next.on('click', function() {
	        $slider.slick('slickNext');
	    });
	
	    $prev.on('click', function() {
	        $slider.slick('slickPrev');
	    });
	}
	
	/** 
	 *  ニュースのタブ
	 */
	function setNewsTab() {
	    var $tab_area = $('#contents-categories-tab', $o.news);
	    var $tab = $('.tab-item', $tab_area);
	    var $news_list = $('.article-news-list', $o.news);
	
	    $('li:first', $tab_area).addClass('current');
	
	    $tab.on('click', function() {
	        var index = $(this).parents('li').index();
	        $('.current', $tab_area).removeClass('current');
	        $(this).parents('li').addClass('current');
	
	        $news_list.filter('.current').removeClass('current');
	        $news_list.eq(index).addClass('current');
	    });
	}
	
	/** 
	 *  実行
	 */
	$(function() {
	    var init = initialize();
	    init.then(initEvent);
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = {
	    smp: '(max-width: 768px)',
	    tablet: '(max-width: 1024px)',
	    pc: '(min-width: 769px)'
	};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// home.bundle.js